document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.getElementById('MobileMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
    menu.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){ menu.hidden = true; toggle.setAttribute('aria-expanded','false'); });
    });
  }

  const packageSelect = document.querySelector('[data-package-select]');
  const packageMap = {
    'Starter': 'Starter — $500/month',
    'Growth': 'Growth — $750/month',
    'Pro': 'Pro — $1,200/month',
    'Elite': 'Elite — $2,000/month'
  };

  function setPackage(plan) {
    if (!packageSelect || !plan) return;
    const desired = packageMap[plan] || plan;
    const option = Array.from(packageSelect.options).find(function(o){ return o.value === desired || o.value.indexOf(plan) === 0; });
    if (option) packageSelect.value = option.value;
  }

  try {
    const planFromUrl = new URLSearchParams(window.location.search).get('plan');
    if (planFromUrl) setPackage(planFromUrl);
  } catch(e) {}

  document.querySelectorAll('.package-cta[data-plan]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      const href = btn.getAttribute('href') || '';
      const plan = btn.getAttribute('data-plan');
      if (href === '#onboarding' || href.endsWith('#onboarding')) {
        e.preventDefault();
        setPackage(plan);
        const target = document.getElementById('onboarding');
        if (target) target.scrollIntoView({behavior:'smooth', block:'start'});
      }
    });
  });
});
